import type { OutflowOfferMobileProps } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers.types';
import { cancelAutoRenewOfferMobile } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/cancelAutoRenew.offer';
import { captchaAndSurveyMobile } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/captchaAndSurvey';
import { checkPauseOffer, pauseOfferMobile } from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/pause.offer';
import {
    checkUnlimitedAutoUploadOffer,
    unlimitedAutoUploadOfferMobile,
} from 'reactApp/modules/subscriptionRenewal/outflowOffers/offers/unlimitedAutoUpload.offer';
import { createOfferProcessor } from 'reactApp/modules/subscriptionRenewal/outflowOffers/subscriptionRenewal.offers';

import { OutflowOffers } from './offers.types';

/**
 * @description Регистрация порядка показа предложений при отписке для тач и вебвью версии
 *
 * @param subscription - подписка
 * @param product - продукт
 * @returns массив указывающий какие оферы и в каком порядке будут показаны
 */
export function getMobileOutflowOffers() {
    return [OutflowOffers.ARE_YOU_SURE, OutflowOffers.PAUSE, OutflowOffers.UNLIMITED_AUTOUPLOAD, OutflowOffers.CAPTCHA_WITH_SURVEY];
}

/**
 * Регистрация предложений для показа
 * @param offer - функция показывающая оффер
 * @param check - функция определяющая доступность показа оффера
 */
export const { processOuflowOfferList: processMobileOuflowOfferList } = createOfferProcessor<OutflowOfferMobileProps>({
    [OutflowOffers.ARE_YOU_SURE]: {
        offer: cancelAutoRenewOfferMobile,
    },
    [OutflowOffers.PAUSE]: {
        check: checkPauseOffer,
        offer: pauseOfferMobile,
    },
    [OutflowOffers.UNLIMITED_AUTOUPLOAD]: {
        check: checkUnlimitedAutoUploadOffer,
        offer: unlimitedAutoUploadOfferMobile,
    },
    [OutflowOffers.CAPTCHA_WITH_SURVEY]: {
        offer: captchaAndSurveyMobile,
    },
});
